(function () {
  var STORAGE_KEY = 'vatDisplayMode';
  var VAT_RATE = 1.2;
  var PRICE_SELECTORS = [
    '.price-item--regular',
    '.price-item--sale',
    '.cart-item__old-price',
    '.cart-item__final-price',
    '.price--end',
    '.totals__total-value',
    '#selected-variant-price',
    '.hulkapps-price .money',
    '[data-hulkapps-ci-price]',
    '.original_price',
    '.discounted_price'
  ].join(', ');

  function parseMoney(text) {
    var match = text.match(/£\s*([\d,]+\.\d{2})/);
    if (!match) return null;
    return { cents: Math.round(parseFloat(match[1].replace(/,/g, '')) * 100) };
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function getMode() {
    /* window.vatToggleDefaultMode is set by Liquid in theme.liquid: 'ex' for a
       logged-in B2B customer, 'inc' for everyone else. A saved choice only
       counts if it was made in the same context (B2B or not) as the current
       visit, otherwise a choice made while logged out would keep overriding
       the B2B default after logging in. A saved value with no context is
       treated as made in the 'inc' context. */
    var fallback = window.vatToggleDefaultMode === 'ex' ? 'ex' : 'inc';
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      var storedContext = window.localStorage.getItem(STORAGE_KEY + 'Context') || 'inc';
      if ((stored === 'ex' || stored === 'inc') && storedContext === fallback) return stored;
    } catch (err) {}
    return fallback;
  }

  function setMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
      /* Remember which context this choice was made in - see getMode(). */
      window.localStorage.setItem(STORAGE_KEY + 'Context', window.vatToggleDefaultMode === 'ex' ? 'ex' : 'inc');
    } catch (err) {
      /* localStorage unavailable (private browsing etc) - toggle still works for this page view */
    }
  }

  function isNonTaxable(el) {
    var host = el.closest('[data-vat-taxable]');
    return !!host && host.dataset.vatTaxable === 'false';
  }

  var currentMode = getMode();

  function isWasPrice(el) {
    /* A "was" price (struck-through compare-at / original price) shouldn't get its
       own inc./ex. VAT annotation - it would just duplicate the label already shown
       next to the actual current price right beside it. Covers this theme's own
       "old price" classes, HulkApps' struck-through span, and any plain <s> tag. */
    if (el.tagName === 'S') return true;
    if (/old-price/i.test(el.className)) return true;
    if (/original_price/i.test(el.className)) {
      /* HulkApps reuses this same class as its DEFAULT wrapper for an item's
         only price too, not just for a genuine was/now pair - only treat it as
         a superseded "was" price when a .discounted_price sibling actually
         follows it. Otherwise this is the item's current (and only) price. */
      return !!(el.nextElementSibling && el.nextElementSibling.classList.contains('discounted_price'));
    }
    if (el.closest('.hulkapps-price')) return true;
    return false;
  }

  function isCartLineItemPrice(el) {
    /* True for a per-line price inside a cart row (item price, line total) -
       both cart-drawer.liquid and main-cart-items.liquid mark their row with
       this same attribute. These prices no longer get their own inline label -
       ensureCartSummaryLabel() below covers the whole cart with one line instead. */
    return !!el.closest('[data-hulkapps-lineitem]');
  }

  function ensureCartSummaryLabel(el) {
    /* el is .totals__total-value. The summary line is inserted as a sibling of
       the whole .totals block, matching the position (and, by reusing the same
       classes, the exact look) of this theme's own native "Shipping and
       discounts calculated at checkout." caption right below it - NOT as a
       sibling of el itself, which would land it INSIDE .totals, where
       component-totals.css's ".totals > *" rule would force the wrong font
       size and an unwanted flex margin (found live, not guessed). */
    var totalsBlock = el.closest('.totals') || el.parentElement;
    var next = totalsBlock.nextElementSibling;
    if (next && next.classList.contains('vat-cart-summary')) return;
    var summary = document.createElement('small');
    summary.className = 'tax-note caption-large rte vat-cart-summary';
    summary.dataset.labelInc = 'Prices shown include VAT';
    summary.dataset.labelEx = 'Prices shown exclude VAT';
    totalsBlock.insertAdjacentElement('afterend', summary);
  }

  function ensureInlineLabel(el) {
    if (isWasPrice(el)) return;
    /* Check the DOM directly for an already-adjacent label, rather than trusting
       el.dataset.vatLabelAdded alone - that flag can go stale (see cleanupOrphanLabels
       below), and trusting it blindly would leave a price permanently unlabeled after
       its stale label gets cleaned up. */
    var next = el.nextElementSibling;
    if (next && next.classList.contains('vat-price-label')) {
      el.dataset.vatLabelAdded = 'true';
      return;
    }
    var label = document.createElement('span');
    label.className = 'vat-price-label';
    label.dataset.labelInc = '(inc. VAT)';
    label.dataset.labelEx = '(ex. VAT)';
    el.insertAdjacentElement('afterend', label);
    el.dataset.vatLabelAdded = 'true';
  }

  function cleanupOrphanLabels() {
    /* Third-party scripts (HulkApps) insert their own elements asynchronously,
       sometimes right where a label already sits, or right inside a wrapper this
       script already labeled before Hulk rewrote it. Both leave a stale/orphaned
       .vat-price-label behind. Sweep them out before every scan so a label is
       always adjacent to exactly one currently-valid price element. */
    document.querySelectorAll('.vat-price-label').forEach(function (label) {
      var prev = label.previousElementSibling;
      if (!prev || !prev.matches(PRICE_SELECTORS)) {
        /* Something (e.g. HulkApps' own cart-total span) got inserted between
           this label and the price it was meant for - the label is now attached
           to the wrong element's neighbourhood. Drop it; ensureInlineLabel() will
           re-add a correctly-placed one for the real price element this pass. */
        label.remove();
        return;
      }
      if (prev.querySelector('.original_price, .discounted_price')) {
        /* prev was a plain price element when labeled, but HulkApps has since
           wrapped it around its own inner spans - the label is now stale, the
           inner spans carry their own labels instead. */
        label.remove();
        delete prev.dataset.vatBaseCents;
        delete prev.dataset.vatLabelAdded;
      }
    });
  }

  function applyToPriceElement(el) {
    /* The HulkApps app wraps cart line prices in its own <span class="original_price">
       (and, when a volume discount is active, also a sibling <span class="discounted_price">)
       INSIDE this element. When that's happened, skip the wrapper itself - it now holds
       two concatenated money values, not one - and let the inner spans (also matched by
       PRICE_SELECTORS) get processed individually instead. */
    if (el.querySelector('.original_price, .discounted_price')) return;

    var parsed = parseMoney(el.textContent);
    if (!el.dataset.vatBaseCents) {
      if (!parsed) return;
      el.dataset.vatBaseCents = String(parsed.cents);
    } else if (parsed) {
      /* Some prices get rewritten by other scripts after this one has already
         captured a base value - #selected-variant-price on the product page is
         rewritten by this theme's own inline script whenever the customer picks
         a different variant. If the currently-rendered amount matches neither
         of the two values THIS script could itself have produced from the
         cached base (the untouched inc-VAT figure, or that figure with VAT
         stripped), something else changed it externally - treat it as a fresh
         base price instead of silently overwriting it back to the stale one. */
      var baseSoFar = parseInt(el.dataset.vatBaseCents, 10);
      var possibleIncCents = baseSoFar;
      var possibleExCents = Math.round(baseSoFar / VAT_RATE);
      if (parsed.cents !== possibleIncCents && parsed.cents !== possibleExCents) {
        el.dataset.vatBaseCents = String(parsed.cents);
      }
    }
    var baseCents = parseInt(el.dataset.vatBaseCents, 10);
    var shouldStripVat = currentMode === 'ex' && !isNonTaxable(el);
    var displayCents = shouldStripVat ? Math.round(baseCents / VAT_RATE) : baseCents;
    var updated = el.textContent.replace(/£\s*[\d,]+\.\d{2}/, formatMoney(displayCents));
    if (el.textContent !== updated) el.textContent = updated;

    if (el.classList.contains('totals__total-value')) {
      /* The cart's grand total gets the one summary line instead of its own
         inline label - see ensureCartSummaryLabel(). */
      ensureCartSummaryLabel(el);
    } else if (!isCartLineItemPrice(el)) {
      /* Every other price (product cards, PDP, search) keeps its own inline
         label as before. A cart line item's price/line total gets neither -
         the single summary line below the total already covers it, so
         repeating "(inc. VAT)" next to every row would be redundant. */
      ensureInlineLabel(el);
    }
  }

  function applyToLabel(el) {
    var text = currentMode === 'inc' ? el.dataset.labelInc : el.dataset.labelEx;
    if (text) el.textContent = text;
  }

  function refresh() {
    cleanupOrphanLabels();
    document.querySelectorAll(PRICE_SELECTORS).forEach(applyToPriceElement);
    document.querySelectorAll('.vat-toggle-label, .vat-price-label, .vat-cart-summary').forEach(applyToLabel);
  }

  function refreshAndSettle() {
    refresh();
    /* The HulkApps volume-discount app rewrites [data-hulkapps-ci-price] and
       [data-hulkapps-line-price] itself after fetching its own copy of the cart
       asynchronously, so it reliably lands after this script's synchronous
       conversion. Re-running shortly after gives it time to finish, then
       corrects anything it overwrote. */
    setTimeout(refresh, 900);
  }

  function applyModeToControls() {
    /* Two control types now share this one state: the desktop checkbox+slider
       (.vat-toggle-input) and the mobile segmented control's two buttons
       (.vat-segment-option, each carrying its mode in data-vat-mode). Whichever
       one the customer used, both stay in sync because both read from the same
       currentMode variable. */
    document.querySelectorAll('.vat-toggle-input').forEach(function (input) {
      input.checked = currentMode === 'inc';
    });
    document.querySelectorAll('.vat-segment-option').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.vatMode === currentMode ? 'true' : 'false');
    });
  }

  function selectMode(mode) {
    if (mode === currentMode) return;
    currentMode = mode;
    setMode(mode);
    applyModeToControls();
    refreshAndSettle();
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyModeToControls();

    document.querySelectorAll('.vat-toggle-input').forEach(function (input) {
      input.addEventListener('change', function () {
        selectMode(input.checked ? 'inc' : 'ex');
      });
    });

    document.querySelectorAll('.vat-segment-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectMode(btn.dataset.vatMode);
      });
    });

    refreshAndSettle();

    var refreshQueued = false;
    function scheduleRefresh() {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(function () {
        refreshQueued = false;
        refresh();
      });
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldRescan = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          shouldRescan = true;
          break;
        }
      }
      if (shouldRescan) scheduleRefresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAndSettle);
      subscribe(PUB_SUB_EVENTS.variantChange, refreshAndSettle);
      subscribe(PUB_SUB_EVENTS.quantityUpdate, refreshAndSettle);
    }
  });
})();